import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';
import { ToastService } from '@app/core/services/toast.service';
import { TranslateService } from '@app/core/services/translate.service';

@Component({
    selector: 'tt-helpdoc',
    templateUrl: './helpdoc.component.html',
    styleUrls: ['./helpdoc.component.css'],
})
export class HelpdocComponent implements OnInit {
    private argtype: HelpdocArgtype;
    private argvalue: string;

    helpdoc?: HelpdocGet;

    settings?: HelpdocSettings;

    languages: Item[] = [];

    relatedHelpdocs: Item[] = [];

    private translations: { [key: string]: string } = { 'saved!': '', changes_have_been_saved: '' };

    saving = false;

    constructor(private datatask: DataTaskService, public state: StateService, private toast: ToastService, private translate: TranslateService) {
        this.argtype = this.state.getStateParams()['argtype'] as HelpdocArgtype;
        this.argvalue = this.state.getStateParams()['argvalue'];
    }

    public async reloadHelpdoc() {
        await this.loadHelpdoc();
        this.loadRelatedList();
    }

    public async save() {
        if (!!this.helpdoc) {
            try {
                this.saving = true;

                const response = await this.datatask.Post(835, this.helpdoc);

                if ('iserror' in response && response.iserror === false) {
                    this.toast.addToast({
                        id: `helpdoc.${this.argtype}.${this.argvalue}.save.${Date.now()}`,
                        type: 'success',
                        title: this.translations['saved!'],
                        message: this.translations['changes_have_been_saved'],
                    });

                    this.loadHelpdoc();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async loadLanguages() {
        this.languages = await this.datatask.Post(57);
    }

    private async loadSettings() {
        this.settings = (await this.datatask.Post(833, { argtype: this.argtype, argvalue: this.argvalue }))[0];
    }

    private async loadHelpdoc() {
        if (!!this.settings) {
            this.helpdoc = (await this.datatask.Post(834, this.settings))[0];
        } else {
            throw Error('Settings need to be loaded before getting helpdoc');
        }
    }

    private async loadRelatedList() {
        if (!!this.helpdoc && !!this.settings) {
            this.relatedHelpdocs = await this.datatask.Post(836, { helpdoctt_keyno: this.helpdoc.helpdoctt_keyno, language_id: this.helpdoc.language_id });
        }
    }

    private async translateWords() {
        const data = await this.translate.translateBatch(Object.keys(this.translations));

        Object.keys(data).forEach((key) => (this.translations[key] = data[key]));
    }

    async ngOnInit(): Promise<void> {
        this.translateWords();
        await this.loadSettings();
        await this.loadHelpdoc();
        this.loadRelatedList();
        this.loadLanguages();
    }
}

type HelpdocArgtype = 'webpage' | 'helpdoctt_keyno_sub' | 'helpdoc_keyno' | 'helpdoctt_keyno' | 'helpdoc_keyno_sub';

interface HelpdocSettings {
    argtype: HelpdocArgtype;
    argvalue: string;
    language_id: string;

    // TODO: add in procedure
    selected_view_tab: string;

    general_edit_mode_tab: string;
    installation_edit_mode_tab: string;
}

interface HelpdocGet {
    heading: string;
    helpdoctt_keyno: string;
    helpdocttlang_keyno: string;
    helpdoctt_headingtext: string;
    helpdoctt_bodytext: string;
    argtype: string;
    argvalue: string;
    language_id: string;
    helpdoc_keyno: string;
    helpdoclang_keyno: string;
    helpdoc_headingtext: string;
    helpdoc_bodytext: string;
    db_name: string;
    helpdoctt_keyno_linkto: string;
    helpdoc_keyno_linkto: string;
    edit_possible: '1' | '0';
    helpdoctt_bodytext_view: string;
    webpage: string;
    show_setting: '1' | '0';
}
